"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _useStylesUtils = require("../../hooks/useStylesUtils");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
const useStyles = props => {
  const {
    isDisabled,
    color = 'primary',
    size = 'medium',
    isChecked
  } = props;
  const {
    fontFamily,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem,
    fontSizeProps
  } = (0, _useStylesUtils.useStylesUtils)();
  const ccRadioStyle = (0, _react.useMemo)(() => {
    const disabledProps = () => {
      if (isDisabled) {
        return {
          opacity: '.5',
          pointerEvents: 'none',
          cursor: 'default'
        };
      }
      return {};
    };
    const btnSizeProps = () => {
      let width;
      let height;
      let marginInlineEnd;
      switch (size) {
        case 'small':
          height = width = pxToRem(14);
          break;
        case 'medium':
          height = width = pxToRem(16);
          break;
        case 'large':
          height = width = pxToRem(18);
          break;
      }
      return {
        width,
        height,
        marginInlineEnd
      };
    };
    const btnCheckedSizeColorProps = () => {
      if (isChecked) {
        const background = color === 'primary' ? themeColors?.primary.main : themeColors?.basic.dark;
        const borderColor = color === 'primary' ? themeColors?.primary.main : themeColors?.basic.dark;
        return {
          background,
          borderColor
        };
      }
      return {};
    };
    const ccRadio = (0, _css.css)({
      display: 'flex',
      fontFamily: fontFamily,
      alignItems: 'start',
      cursor: 'pointer',
      ...fontSizeProps(size),
      ...disabledProps(),
      '&:first-child': {
        marginBlockStart: 0
      }
    });
    const ccRadioBtn = (0, _css.css)({
      position: 'relative',
      top: pxToRem(3.4),
      borderRadius: '50%',
      border: `1px solid ${themeColors?.general.subText}`,
      boxShadow: `inset 0 0 0 ${pxToRem(2)} ${themeColors?.general.light}`,
      flexShrink: 0,
      ...btnSizeProps(),
      ...btnCheckedSizeColorProps()
    });
    const ccRadioLabel = (0, _css.css)({
      marginInlineStart: pxToRem(8)
    });
    return {
      ccRadio,
      ccRadioBtn,
      ccRadioLabel
    };
  }, [color, fontFamily, fontSizeProps, isChecked, isDisabled, pxToRem, size, themeColors?.basic.dark, themeColors?.general.light, themeColors?.general.subText, themeColors?.primary.main]);
  return {
    'cc-Radio': ccRadioStyle.ccRadio,
    'cc-Radio__btn': ccRadioStyle.ccRadioBtn,
    'cc-Radio__label': ccRadioStyle.ccRadioLabel
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;